/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Callback_Desktop_Success_TitleInputs */

const en_common_auth_callback_desktop_success_title = /** @type {(inputs: Common_Auth_Callback_Desktop_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're signed in`)
};

const zh_common_auth_callback_desktop_success_title = /** @type {(inputs: Common_Auth_Callback_Desktop_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录成功`)
};

/**
* | output |
* | --- |
* | "You're signed in" |
*
* @param {Common_Auth_Callback_Desktop_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_callback_desktop_success_title = /** @type {((inputs?: Common_Auth_Callback_Desktop_Success_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Callback_Desktop_Success_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_callback_desktop_success_title(inputs)
	return zh_common_auth_callback_desktop_success_title(inputs)
});
export { common_auth_callback_desktop_success_title as "common.auth.callback.desktop_success_title" }